export default __webpack_public_path__ + "static/media/ShedularRight.9871dbdc.svg";